import {useState, useEffect} from 'react';

// Mui & Components
import {styled} from '@material-ui/core/styles';
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';

// Redux
import {RootState} from '../store/store';
// import {setLogout} from '../store/loginUserInfoSlice';
import {useSelector, useDispatch} from 'react-redux';

// Router
import {Outlet, useNavigate} from 'react-router-dom';

// Toast
import {toast} from 'react-toastify';

// i18n
import {useTranslation} from 'react-i18next';

// Zendesk
import ZendeskComp from './zendesk/ZendeskComp';

const DashboardLayoutRoot = styled('div')(({theme}) => ({
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  flexDirection: 'column',
  //   height: '100%',
  overflow: 'hidden',
  width: '100%',
}));

const DashboardLayoutWrapper = styled('div')(({theme}) => ({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
  //   paddingTop: 64,
  marginTop: 64,
  [theme.breakpoints.up('lg')]: {
    paddingLeft: 256,
  },
}));

const DashboardLayoutContainer = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
  height: 'calc(100vh - 64px)',
});

const DashboardLayoutContent = styled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto',
});

const DashboardLayout = () => {
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const discordUserInfo = useSelector(
    (state: RootState) => state.user.discordUserInfo,
  );
  const {t, i18n} = useTranslation();

  // useEffect(() => {
  //   if (!discordUserInfo?.isLogin) {
  //     toast.warning(t('Session Expired'), {
  //       toastId: 'UNAUTHORIZED_NO_LOGIN',
  //     });
  //     dispatch(setLogout());
  //     navigate('/login');
  //   }
  // }, []);

  return (
    <DashboardLayoutRoot data-id="DashboardLayoutRoot">
      <DashboardNavbar
        onMobileNavOpen={() => {
          console.log('onMobileNavOpen');
          setMobileNavOpen(true);
        }}
      />
      <DashboardSidebar
        onMobileClose={() => {
          console.log('close silder');
          setMobileNavOpen(false);
        }}
        openMobile={isMobileNavOpen}
      />
      <DashboardLayoutWrapper data-id="DashboardLayoutWrapper">
        <DashboardLayoutContainer>
          <DashboardLayoutContent>
            <Outlet />
          </DashboardLayoutContent>
        </DashboardLayoutContainer>
      </DashboardLayoutWrapper>
      <ZendeskComp />
    </DashboardLayoutRoot>
  );
};

export default DashboardLayout;
